module.exports = __webpack_public_path__ + "fb83bc6f70bb68bd9b0c787d1a0575bc.png";